import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import TextInput from '../../Components/TextInput'
import StaticTextInput from '../../Components/StaticTextInput'
import Checkbox from '../../Components/Checkbox'
import RadioButton from '../../Components/RadioButton'
import helpers from '../../Utils/helpers'
import LeadsOrderDropdown from '../../Components/Leads/LeadsOrderDropdown'
import customerActions from '../../Actions/customerActions'
import commonActions from '../../Actions/commonActions'
import ResellerSearch from '../../Components/ResellerSearch'
import { useTranslation } from "react-i18next";
import Spinner from "../../Components/Fundamentals/Spinner/Spinner";

function BookEducationContainer({ commonActions, bookEducationForm, education }) {
    const { t } = useTranslation();

    const onFieldChange = (field, value) => {
        commonActions.changeMultiFormField(bookEducationForm.id, field, value)
    }

    const copyContactPerson = () => {
        const booking = bookEducationForm.data;
        onFieldChange('participantFirstName', booking.contactFirstName);
        onFieldChange('participantLastName', booking.contactLastName);
        onFieldChange('participantMobilenumber', booking.contactMobilenumber);
        onFieldChange('participantEmail', booking.contactEmail);
    }

    if (!bookEducationForm || !education) {
        return <Spinner />
    }

    const booking = bookEducationForm.data;

    return <form title={t('customernavigation.bookeducation')}>
            <div className="form-horizontal">
                <div className="col-sm-12 col-md-8">
                    <StaticTextInput label={t('common.customernumber')} value={booking.customerNumber} />
                    <ResellerSearch label={t('educations.searchreseller')} onChange={(supplierNumber) => onFieldChange('reseller', supplierNumber)} />
                    <StaticTextInput label={t('common.name')} value={booking.name} />
                    <StaticTextInput label={t('educations.course')} value={education.name} />
                    <StaticTextInput label={t('educations.educationdate')} value={helpers.formatDate(education.date)} />
                    <StaticTextInput label={t('educations.location')} value={education.location} />
                    <StaticTextInput label={t('common.price')} value={helpers.currencyFormatter(education.price)} />
                    <TextInput label={t('common.salesnumber')} onChange={onFieldChange.bind(this, 'salesNumber')} value={booking.salesNumber} />
                    <TextInput label={t('educations.invoiceref')} onChange={onFieldChange.bind(this, 'invoiceReference')} value={booking.invoiceReference} maxAmountOfCharacters={200} />
                </div>
            </div>
            <div className="form-horizontal">
                <div className="col-sm-12 col-md-8">
                    <h3>{t('common.contactperson')}</h3>
                    <TextInput label={t('common.firstname')} onChange={onFieldChange.bind(this, 'contactFirstName')} value={booking.contactFirstName} maxAmountOfCharacters={100} hideAdditionalInfo={true} />
                    <TextInput label={t('common.lastname')} onChange={onFieldChange.bind(this, 'contactLastName')} value={booking.contactLastName} maxAmountOfCharacters={100} hideAdditionalInfo={true} />
                    <TextInput label={t('common.phonenumber')} onChange={onFieldChange.bind(this, 'contactMobilenumber')} value={booking.contactMobilenumber} type="tel" maxAmountOfCharacters={100} hideAdditionalInfo={true} />
                    <TextInput label={t('common.email')} onChange={onFieldChange.bind(this, 'contactEmail')} value={booking.contactEmail} type="email" maxAmountOfCharacters={200} hideAdditionalInfo={true} />
                </div>
            </div>
            <div className="form-horizontal">
                <div className="col-sm-12 col-md-8">
                    <h3>{t('educations.participant')}</h3>
                    <TextInput label={t('common.firstname')} onChange={onFieldChange.bind(this, 'participantFirstName')} value={booking.participantFirstName} maxAmountOfCharacters={100} hideAdditionalInfo={true} />
                    <TextInput label={t('common.lastname')} onChange={onFieldChange.bind(this, 'participantLastName')} value={booking.participantLastName} maxAmountOfCharacters={100} hideAdditionalInfo={true} />
                    <TextInput label={t('common.phonenumber')} onChange={onFieldChange.bind(this, 'participantMobilenumber')} value={booking.participantMobilenumber} type="tel" maxAmountOfCharacters={100} hideAdditionalInfo={true} />
                    <TextInput label={t('common.email')} onChange={onFieldChange.bind(this, 'participantEmail')} value={booking.participantEmail} type="email" maxAmountOfCharacters={200} hideAdditionalInfo={true} />
                    <div className="float-right">
                        <button type="button" className="btn btn-default btn-sm" onClick={copyContactPerson.bind(this)}>Use Contact Person</button>
                    </div>
                    <TextInput label={t('educations.additionalinfo')} onChange={onFieldChange.bind(this, 'additionalInfo')} value={booking.additionalInfo || ""} maxAmountOfCharacters={255} multiline={true} />
                    <TextInput label={t('educations.coupon')} onChange={onFieldChange.bind(this, 'couponCode')} value={booking.couponCode} />
                    <div className="form-group">
                        <div className="col-md-4 col-12 control-label"></div>
                        <Checkbox label={t('educations.bookingterms')} onChange={(element) => { onFieldChange('bookTerms', element.checked) }} link='https://www.spiris.se/villkor/bokningsvillkor-utbildning' value={booking.bookTerms} checked={booking.bookTerms}/>
                    </div>
                    <LeadsOrderDropdown onChange={onFieldChange.bind(this, 'leadId')} leadId={booking.leadId} />
                </div>
            </div>
        </form>
}

function mapStateToProps(state) {
    return {
        customer: state.CustomerReducer.customer,
        userSalesNumber: state.CommonReducer.user && state.CommonReducer.user.salesNumber,
        bookEducationForm: state.CommonReducer.forms && state.CommonReducer.forms.bookEducation,
        education: state.CustomerReducer.selectedEducation
    }
}

function mapDispatchToProps(dispatch) {
    return {
        customerActions: bindActionCreators(customerActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BookEducationContainer);